<template>
  <Ai />
</template>

<script setup lang="ts">
import Ai from "@/assets/vectors/ai.svg";
</script>
